import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import Kicker from './Kicker';

export default function PageHeader({
  kicker,
  title,
  subtitle,
  action,
  actionLabel,
  onAction,
  children,
}) {
  return (
    <Box sx={{ mb: 3 }}>
      {kicker && <Kicker sx={{ mb: 0.5 }}>{kicker}</Kicker>}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              letterSpacing: '-0.02em',
              lineHeight: 1.1,
              fontSize: { xs: '2rem', md: '2.5rem' },
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body1" color="text.secondary" sx={{ mt: 1, maxWidth: 560, fontWeight: 500, lineHeight: 1.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action || (actionLabel && onAction && (
          <Button variant="contained" onClick={onAction}>
            {actionLabel}
          </Button>
        ))}
      </Box>
      {children}
    </Box>
  );
}
